import * as gql from 'gql-query-builder';

import { userGeolocationFields, maintenanceFields } from './fields';

export enum ConfigOperations {
  Geolocation = 'geolocation',
  Maintenance = 'healthcheck',
}

const marketQql = {
  getUserGeolocation: () => {
    return gql.query({
      operation: ConfigOperations.Geolocation,
      fields: userGeolocationFields,
    });
  },

  getMaintenance: () => {
    return gql.query({
      operation: ConfigOperations.Maintenance,
      fields: maintenanceFields,
    });
  },
};

export default marketQql;
